export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["PENDING"] = "pending";
    TaskStatus["IN_PROGRESS"] = "in_progress";
    TaskStatus["UNDER_REVIEW"] = "under_review";
    TaskStatus["COMPLETED"] = "completed";
    TaskStatus["CANCELLED"] = "cancelled";
})(TaskStatus || (TaskStatus = {}));
export var TaskType;
(function (TaskType) {
    TaskType["SKILL_DEVELOPMENT"] = "skill_development";
    TaskType["PROJECT_WORK"] = "project_work";
    TaskType["CAREER_GUIDANCE"] = "career_guidance";
    TaskType["RESEARCH"] = "research";
    TaskType["READING"] = "reading";
    TaskType["PRACTICE"] = "practice";
    TaskType["OTHER"] = "other";
})(TaskType || (TaskType = {}));
export var ResourceType;
(function (ResourceType) {
    ResourceType["LINK"] = "link";
    ResourceType["DOCUMENT"] = "document";
    ResourceType["VIDEO"] = "video";
    ResourceType["BOOK"] = "book";
    ResourceType["COURSE"] = "course";
    ResourceType["OTHER"] = "other";
})(ResourceType || (ResourceType = {}));
//# sourceMappingURL=task-status.enum.js.map